module.exports = __webpack_public_path__ + "static/media/cam-3.98de1337.webp";